module.exports = __webpack_public_path__ + "img/business-owner.45e0a2f1.jpg";